import LendiAppBridge from '@lendi/lendi-app-bridge';

export default new LendiAppBridge();
